/* ENERGYofSUN Theme JavaScript */
(function() {
  'use strict';

  /* ---- Mobile Menu ---- */
  const menuToggle = document.querySelector('.site-header__menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('.mobile-menu__close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
    if (menuClose) menuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
  }

  /* ---- Product Page: Image Gallery ---- */
  const mainImage = document.querySelector('.product-page__main-image img');
  const thumbs = document.querySelectorAll('.product-page__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  /* ---- Product Page: Variant Selection ---- */
  const variantBtns = document.querySelectorAll('.product-page__variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.product-page__variant-options');
      if (group) {
        group.querySelectorAll('.product-page__variant-btn').forEach(b => b.classList.remove('active'));
      }
      btn.classList.add('active');
      // Update hidden variant ID input
      const variantId = btn.dataset.variantId;
      const input = document.querySelector('input[name="id"]');
      if (input && variantId) input.value = variantId;
    });
  });

})();
